import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, state } = useLocation();

  // Use useLayoutEffect for synchronous scroll before paint
  useLayoutEffect(() => {
    // Don't scroll to top if there's a scrollTo state (for anchor navigation)
    if (state?.scrollTo) {
      return;
    }
    
    // Force scroll to top with multiple methods for browser compatibility
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname, state]);

  return null;
};

export default ScrollToTop;
